module.exports = __webpack_public_path__ + "web/img/icon1.f581939f.png";